export function getAsyncEntityNextUpdatedData(prev, data) {
  return data
}
